<template>
  <div class="position-paper-view">
    <div class="subsection-header">
      <h6>Position Papers</h6>
    </div>
    
    <div v-if="positionPapers?.length" class="papers-list">
      <div v-for="(paper, index) in positionPapers" :key="index" class="paper-item">
        <div class="paper-header">
          <span>Position Paper #{{ index + 1 }}</span>
        </div>
        <div class="form-grid">
          <div class="form-group">
            <label>Position Title:</label>
            <span>{{ paper.positiontitle || '-' }}</span>
          </div>
          <div class="form-group">
            <label>Status:</label>
            <span>{{ paper.status || '-' }}</span>
          </div>
          <div class="form-group">
            <label>Date:</label>
            <span>{{ paper.date || '-' }}</span>
          </div>
          <div class="form-group">
            <label>Link:</label>
            <a v-if="paper.source" :href="paper.source" target="_blank" class="link">{{ paper.source }}</a>
            <span v-else>-</span>
          </div>
        </div>
      </div>
    </div>
    
    <div v-else class="no-data">
      No position papers available
    </div>
  </div>
</template>

<script setup>
defineProps({
  positionPapers: {
    type: Array,
    default: () => []
  }
})
</script>

<style scoped>
.position-paper-view {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.subsection-header {
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.subsection-header h6 {
  color: #1e3a8a;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
}

.papers-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.paper-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 1rem;
}

.paper-header {
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.form-group label {
  font-weight: 600;
  color: #1e3a8a;
  font-size: 0.9rem;
}

.form-group span {
  color: #6b7280;
  font-size: 0.9rem;
}

.form-group .link {
  color: #1e3a8a;
  font-size: 0.9rem;
  text-decoration: underline;
  word-break: break-all;
}

.form-group .link:hover {
  color: #3b82f6;
}

.no-data {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 2rem;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}
</style>